module.exports = __webpack_public_path__ + "img/09.76d33acb.jpg";